/**
 * Default list ordering: most recently touched records first (updated_at, then created_at).
 */

export function getRecordSortTime(record) {
  if (!record || typeof record !== 'object') return 0;
  const fields = ['updated_at', 'updatedAt', 'created_at', 'createdAt', 'dateCreation', 'date'];
  for (const field of fields) {
    const value = record[field];
    if (value == null || value === '') continue;
    const time = new Date(value).getTime();
    if (!Number.isNaN(time)) return time;
  }
  return 0;
}

/** Returns a new array sorted newest-first (safe after API fetch). */
export function sortRecordsNewestFirst(records) {
  if (!Array.isArray(records)) return [];
  return [...records].sort(compareByNewestFirst);
}

export function compareByNewestFirst(a, b) {
  const timeDiff = getRecordSortTime(b) - getRecordSortTime(a);
  if (timeDiff !== 0) return timeDiff;

  const idA = parseInt(String(a?.id ?? ''), 10) || 0;
  const idB = parseInt(String(b?.id ?? ''), 10) || 0;
  if (idB !== idA) return idB - idA;

  return String(b?.id ?? '').localeCompare(String(a?.id ?? ''));
}

export const DEFAULT_LIST_SORT = { key: 'created_at', direction: 'desc' };
